import React from 'react'
import {connect} from "react-redux";
import PropTypes from 'prop-types'

const KEYWORD_MODAL_ID = "keyword"

import { 
  selectActiveModal,
  selectKeywordText,
  selectKeywordValue,
  selectKeywordCompletions
} from '../../State/selectors.js'

import {
  openModal,
  closeModal,
  searchKeywordText,
  changeKeywordText,
  completeKeywordMatch
} from '../../State/actions.js'

const mapStateToProps = (state) => {
  var dropdownOpen = selectActiveModal(state) === KEYWORD_MODAL_ID 
  var keywordText = selectKeywordText(state)
  var keywordValue = selectKeywordValue(state)

  // eslint-disable-next-line no-console
  // console.log(selectKeywordCompletions(state))

  var completions = keywordText && keywordText.length > 0 
    ? selectKeywordCompletions(state)
    : []

  return { dropdownOpen, keywordValue, keywordText, completions }
}

const actions = {
  openModal,
  closeModal,
  changeKeywordText,
  searchKeywordText,
  completeKeywordMatch
}


class KeywordSearchInput extends React.Component {
  static get propTypes () {
    return {
      dropdownOpen: PropTypes.bool,
      openModal: PropTypes.func,
      closeModal: PropTypes.func,
      searchKeywordText: PropTypes.func,
      changeKeywordText: PropTypes.func,
      keywordValue: PropTypes.string,
      keywordText: PropTypes.string,
      completions: PropTypes.array,
      completeKeywordMatch: PropTypes.func
    }
  }

  handleChange (e) {
    var { changeKeywordText } = this.props
    changeKeywordText(e.target.value)
  }

  handleClickOutside (event) {
    var { closeModal } = this.props
    const domNode = this.dropdownRef;

    if (!domNode || !domNode.contains(event.target)) {
      closeModal()
    }
  }

  preventSubmit (e) {
    e.preventDefault()
    this.handleKeywordSearch()
  }

  handleCompletion (id) {
    var { 
      completeKeywordMatch 
    } = this.props

    completeKeywordMatch(id)
  }

  handleKeywordSearch () {
    var { keywordText, searchKeywordText } = this.props
    searchKeywordText(keywordText)
  }

  renderCompletions () {
    var { 
      completions, keywordText 
    } = this.props


    var out = completions.map( group => {
      return (
        <div key={group.paramName}>
          <h4 className="fdn-search-dropdown-header uk-margin-remove">
            {group.paramName}
          </h4>
          <ul className="uk-list uk-margin-remove uk-padding-remove">
            {group.filters.map( f => {
              return (
                <li key={f.id}
                  className="uk-flex uk-flex-between
                  uk-animation-toggle fdn-search-dropdown-item uk-margin-remove"
                  onClick={() => this.handleCompletion(f.id)}>

                  <span className="uk-flex-1">{f.name}</span>
                  <span data-uk-icon="icon: plus"></span>
                </li>
              )
            })}
          </ul>
        </div>
      )
    })

    out.unshift(
      <div key="keyword-search">
        <ul className="uk-list uk-padding-remove">
          <li className="fdn-search-dropdown-item uk-margin-remove" 
            onClick={() => this.handleKeywordSearch()}>
            {`Search with keyword "${keywordText}"`}
          </li>
        </ul>
      </div>
    )
    return out
  }

  render () {
    var { dropdownOpen, openModal, keywordValue, keywordText } = this.props

    return (
      <div className="uk-position-relative bar-link keyword-wrap uk-flex-1"
        ref={node => this.dropdownRef = node}>

        <form className="uk-search uk-search-default uk-width-1-1 ev-keyword-form"
          onSubmit={(e) => {this.preventSubmit(e)}}>
          <span uk-search-icon="icon: search"></span>
          <input className="fdn-search-input uk-search-input keyword-search"
            id="location-keywords" 
            autoComplete="off" 
            type="search" 
            placeholder={ keywordValue ? "" : "Keywords" }
            value={ keywordText || "" }
            onFocus={() => openModal("keyword")}
            onChange={this.handleChange.bind(this)}/>
        </form>

        { 
          dropdownOpen 
            ? 
            <KeywordDropdown 
              dropdownOpen={dropdownOpen}
              handleClose={this.handleClickOutside.bind(this)}>
              { 
                !keywordText 
                ?
                <li className="uk-margin-remove uk-padding-xsmall">
                  Enter text to search...
                </li>
                :
                this.renderCompletions() 
              }
            </KeywordDropdown> 
            : 
            null 
        }
      </div>
    )
  }
}

class KeywordDropdown extends React.Component {
  static get propTypes () {
    return {
      dropdownOpen: PropTypes.bool,
      children: PropTypes.node,
      handleClose: PropTypes.func
    }
  }

  constructor () {
    super()

    this.handleClose = this.handleClose.bind(this)
  }

  handleClose (e) {
    this.props.handleClose(e)
  }

  componentDidMount () {
    document.addEventListener('click', this.handleClose, true);
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.handleClose, true);
  }

  render () {
    return (
      <div className="fdn-search-dropdown-spacer">
        <div className="fdn-search-dropdown">
          <ul className="uk-list uk-list-divider uk-margin-remove">
            { this.props.children }
          </ul>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, actions)(KeywordSearchInput);
